/**
* In Add Hospital function is used to add or create new hospital details and it's functions declare this file
**/
import { useState} from 'react';
import { useNavigate,Link } from 'react-router-dom';
import * as Yup from 'yup';
import { validate } from '../../../services/ValidationService';
import ApiService from '../../../services/ApiService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ImageCroper from '../../../shared/modals/ImageCroper'
import { goBack,dataURItoBlob,filterGeoLocation,hashPassword,generateRandomPassword} from '../../../services/UtilsService';
import { toast } from 'react-toastify';
import Autocomplete from 'react-google-autocomplete';
import NavigationModal from '../../../shared/modals/NavigationModal';
import { useTranslation } from 'react-i18next';

function AddHospital(){
  //Intial state declaration
  const [data,setData]=useState({});
  const [error,setError]=useState({});
  const [isValid,setValid]=useState(true);
  const navigate = useNavigate();
  const [show,SetShow]=useState(false);
  const [image, setImage] = useState('');
  const [cropImge, setCropImage] = useState();
  const [tab,setTab]=useState(0);
  const [showModal, setShowModal] = useState(false);  // State for navigation modal visibility
  const [dynamicId, setDynamicId] = useState(null);  // State for navigation id
  const [modalMessage, setModalMessage] = useState('');  // State for navigation modal message
  const { t } = useTranslation();
	

  //validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  //callback function
  const handleClose = () => {
	SetShow(false);
	// Reset the file input value
	const fileInput = document.getElementById('file-5');
	if (fileInput) {
	  fileInput.value = ""; // Clear the file input so the same file can be selected again
	}
  };
	const imageData= (data)=> setCropImage(data)
   
   
    /** 
	* Validation schema for Hospital Fields
	* @name - required field and pass the hospital name
	* @admin_first_name - required field and pass the admin first_name
	* @admin_last_name - required field and pass the admin last_name
	* @website - required field and pass the hospital website
	* @email - required field and should be in correct hospital email format 
	* @admin_email - required field and should be in correct admin email format 
	* @mobileNumber - required field and pass the hospital mobileNumber
	* @admin_mobileNumber - required field and pass the admin mobileNumber
	* @admin_gender - required field and pass the admin gender 
	* @city - required field and pass the hospital city 
	* @state - required field and pass the hospital state
	* @zipcode - required field and pass the hospital zipcode
	**/
   const fields = [
    { name: 'name', validation: Yup.string().trim().required(t('error.required')) },
    { name: 'admin_first_name', validation: Yup.string().trim().required(t('error.required')) },
    { name: 'admin_last_name', validation: Yup.string().trim().required(t('error.required')) },
	{ name: 'website', validation: Yup.string().trim().nullable()/* .required(t('error.required')) */ },
	{ 
	name: 'email', 
	validation: Yup.string()
		.nullable()
		.test(t('error.emailInvalid'), t('error.emailInvalid'), (value) => { 
		return !value || emailPattern.test(value); // Allow empty string or validate with pattern
		})
		// .required(t('error.emailRequired')) // Commented out since it's optional
	},
	{ 
	name: 'admin_email', 
	validation: Yup.string()
		.test(t('error.emailInvalid'), t('error.emailInvalid'), (value) => { 
		return emailPattern.test(value); 
		})
		.required(t('error.emailRequired'))
	},
	{ name: 'mobileNumber', validation: Yup.string().required(t('error.required')) },
	/* { name: 'admin_mobileNumber', validation: Yup.string().required(t('error.required')) }, */
	/* { name: 'admin_gender', validation: Yup.string().required(t('error.required'))}, */
	{ name: 'city', validation: Yup.string().required(t('error.required'))},
	{ name: 'state', validation: Yup.string().required(t('error.required')) },
	{
	name: 'zipcode',
	validation: Yup.string()
		.required(t('error.required')) 
		.matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha'))
	},
   ];
   
   /** 
   * To handle input change event 
   * @e - we get the event details from the Change action
   **/
  const handleChange=async(e)=>{
	  const { name , value } =e.target;
	  e.preventDefault();
	  setData({...data,[name]:value});
	  const Errors = await validate({ [name]: value }, fields);
	  setError({...error,[name]:Errors[name]});
  };
  
  /** 
  * To handle submit event 
  * @e - we get the event details from the form submit action
  **/
  const handleSubmit=async(e)=>{
	  e.preventDefault();
	  const Errors = await validate(data, fields);
	  setError(Errors);
	  const requiredFieldsForTab0 = ['name', 'website', 'email', 'mobileNumber', 'city', 'state', 'zipcode']; // List of fields that need to trigger setTab(0) if they have errors
	  const hasErrorsInTab0 = requiredFieldsForTab0.some(field => Errors[field]); // Check if any of the required fields have errors
	  if (hasErrorsInTab0) { // If there are errors in any of the specified fields, move to setTab(0)
		  setTab(0);
	  }
	  if(!Object.keys(Errors).length && isValid){
		const createTemporaryPassword =await generateRandomPassword();
		const hashTemporaryPassword =await hashPassword(createTemporaryPassword);
		data.email = data.email || null;
		data.website = data.website || null;
		data.admin_password = hashTemporaryPassword;
		if (data.geo_location) {
			data.location = data.geo_location; // Assign the value of geo_location to location
			delete data.geo_location; // Remove the old geo_location property
		}		
		  var response = await ApiService.createOrganization(data);
		  if(response.status===200){
			 if (cropImge !== undefined) {
				const formData = new FormData();
				const fileConvertData =await dataURItoBlob(cropImge);
				formData.append('file', fileConvertData);
				 await ApiService.uploadNewPhoto(response?.data?.orgId,formData);
			}  
			toast.success(response?.data?.message);
			//navigate('/admin/hospital');  
			// Set dynamic ID and message for modal
			await setDynamicId(response?.data?.orgId);  // Assuming the physician ID is in the response
			await setModalMessage(t('modal.mapPhyAndParToHospital'));
			await setShowModal(true); // Show modal after success 
		  }else{
			  toast.error(response?.data?.message || response?.data?.error[0]?.message||'Something went wrong');
		  }
	  }
  };

  /** To go to next page 
  * @tab - pass the selected tab value 
  * @e - we get the event details from the click action
  **/
  const goNext=(tab)=>async(e)=>{
	e.preventDefault();
	if(tab===0){
	  const nonAdminFields = fields.filter(field => !field.name.startsWith('admin_')); // Filter out fields that don't start with 'admin_'
	  const Errors = await validate(data, nonAdminFields); // Validate only non-admin fields
	  setError(Errors);
	  if(!Object.keys(Errors).length && isValid){
		  // Before moving to next tab, validate mobile uniqueness via API
		  const ok = await checkHospitalMobile();
		  if (ok) setTab(1);
	  }
	}
};

	// Helper: call backend to check hospital mobile uniqueness
	const checkHospitalMobile = async () => {
		try {
			// Only call API if mobile number and country code are present
			if (!data?.mobileNumber || !data?.countryCode) return true;
			const payload = { mobileNumber: String(data.mobileNumber), countryCode: String(data.countryCode) };
				const resp = await ApiService.checkHospitalMobileNumber(payload);
				if (resp && resp.status === 200) {
					return true;
				}
				// If API returns 409 with message, treat as taken
				if (resp && resp.status === 409) {
					const msg = resp.data?.message || 'This mobile number is already taken';
					toast.error(msg);
					setError(prev => ({ ...prev, mobileNumber: msg }));
					return false;
				}
				// Any other non-200 response - treat as failure to validate and prevent next
				const msg = resp?.data?.message || 'Error checking mobile number';
				toast.error(msg);
				setError(prev => ({ ...prev, mobileNumber: msg }));
				return false;
		} catch (err) {
			// If backend responds with 409, show toast and set field error
			const status = err?.response?.status;
			const msg = err?.response?.data?.message || t('common.error');
			if (status === 409) {
				toast.error(msg);
				setError(prev => ({ ...prev, mobileNumber: msg }));
				return false;
			}
			// On other errors, show generic toast but allow progression
				toast.error(err?.response?.data?.message || 'Error checking mobile number');
				return false;
		}
	};
  
  /** 
  * To check phone number valid or not 
  * @value - we pass the actual phone number
  * @country - we pass the countryCode
  * @e - we get the event details from the onChange action
  * @formattedValue - we pass the country formatted Value
  **/
  const handlePhone= async(value, country, e, formattedValue) => {
      const {format, dialCode} = country;
	  if (e.target.name === 'mobileNumber') {
        // Store data for mobileNumber as countryCode, countryNameCode, and mobileNumber separately
        setData({
            ...data,
            [e.target.name]: formattedValue.split("+" + dialCode + " ")[1],  // Store mobile number only
            countryCode: '+' + dialCode,
            countryNameCode: country?.countryCode,
			mobileNumberWithCode: e.target.value
        });
    } else if (e.target.name === 'admin_mobileNumber') {
        const cleanedNumber = `+${dialCode} ${formattedValue.split("+" + dialCode + " ")[1]?.replace(/[^0-9+]/g, '')}`; // Remove special characters from the admin_mobileNumber except '+'
        setData({
            ...data,
            [e.target.name]: cleanedNumber,  // Store countryCode + admin_mobileNumber without special characters
			admin_mobileNumberWithCode: cleanedNumber,
        });
    }

    // Validate the phone input
    const Errors = await validate({ [e.target.name]: formattedValue }, fields);
    setError({ ...error, [e.target.name]: Errors[e.target.name] });
      if (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value))) {
	       setValid(true);
	  }else{
		   setValid(false);
	  }
	  if (e.target.name === 'admin_mobileNumber' && e.target.value.trim() === '') {
		setValid(true);
	  }
  }
  
  /** 
  * To handle the image change
  * @e - we get the event details from the input file select action
  **/
  const handleFile=async (e)=>{
	  e.preventDefault();
	  const file = e.target.files[0];
	  openCropModal(file);

  }
  
  /** 
  * To open the image crop modal
  * @file - we pass the image details in the base 64 bit format
  **/
  const openCropModal=async(file)=>{
	  
	  if(file){
		 let ext = file.name.split('.').pop();
		 let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
		 if (!allowedExtensions.includes(ext)) {
				toast.error(t('error.fileFormat'));
				await SetShow(false);
				 return;
			}
		if (file.size > 100 * 1024 * 1024) {
			toast.error(t('error.fileSize'));
				await SetShow(false);
				 return;
		}
		 const reader = new FileReader();
		 reader.onload = () => { setImage(reader.result) };
		 reader.readAsDataURL(file);
		 await SetShow(true);
	 }else{
		 await SetShow(false);
	 }
  }
  
  /** 
  * To handle event drag
  * @e - we get the event details from the drag over action
  **/
  const handleDrag=(e)=>{
	  e.preventDefault();
  }
  
  /** 
  * To handle event drop
  * @e - we get the event details from the drop over action
  **/
  const handleDrop=(e)=>{
	  e.preventDefault();
	   const { files } = e.dataTransfer;
	   openCropModal(files[0]);
  }
  
  /** 
  * To change city input 
  * @e - we get the event details form the change action
  **/
  const changeCity=async(e)=>{
         const { value }=e.target;
		 var obj={};
		 if(value.trim().length ===0){
			 obj={city:'',state:''};
		 }else{
		     obj={city:value};
		 }
		 setData((data)=>({...data,...obj}));
		 const Errors = await validate({ city:value }, fields);
	     setError({...error,city:Errors['city']});
  }
  
  /** 
  * To select city input 
  * @e - we get the event details from the Select action
  **/
  const selectCity=async(e)=>{ 
		// Access address_one and address_two from the data object
		const addressOne = data.address_one || null;
		const addressTwo = data.address_two || null;
	    var location= await filterGeoLocation(e, addressOne, addressTwo);

		await setData((data)=>({...data,...location}));
  }
  
  // Handle user confirmation actions for navigation 
  const handleYes = () => {
    setShowModal(false);
	navigate(`/admin/edit-hospital/${dynamicId}`);
  };
  const handleNo = () => {
    setShowModal(false);
	navigate('/admin/hospital');
  };
  
  return (
  <main id="main" className="main">
  {/*import ImageCroper*/}
  <ImageCroper 
		show={show} 
		handleClose={handleClose}
		image={image}
		cropImge={imageData}
	/>
	{/* Modal for navigation */}
	<NavigationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        message={modalMessage}
        onYes={handleYes}
        onNo={handleNo}
      />
		{/*Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			<h1>{t('profile.hospitalInfo')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item"><Link to='/admin/hospital'>{t('sidebar.hospital')}</Link></li>
					  <li className="breadcrumb-item active">{t('profile.hospitalInfo')} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}
		
		{/*Page Content Section*/}
		<section>
		<div className="row">
			{/*ProfileImg*/}
			<div className="col-xxl-3">
				<div className="card profile-img">
					<div className="card-body">
						<div className="upload-box d-none d-lg-block">		
							<div className="box text-center"  onDrop = {handleDrop} onDragOver = {handleDrag}>
								<input type="file" onChange={handleFile} name="file-5" id="file-5" className="inputfile inputfile-4"  />
								<label htmlFor="file-5">
								{cropImge?(<img  className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />):(<img  className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="lo" />)}
									<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
								</label>
							</div>
						</div>
						<div className="text-center text-tmBlue mt-4">
							<h6>{t('profile.uploadPicture')}</h6>
						</div>
					</div>
				</div>
            </div>
			
			{/*Organization Info*/}
			<div className="col-xxl-9">
				<div className="card form-card profile-info ">
					<div className="card-body pt-4">
						<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
						  <li className="nav-item" role="presentation">
							<span onClick={()=>setTab(0)} className={tab===0?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.organisationInfo')}</span>
						  </li>
													<li className="nav-item" role="presentation">
														<span onClick={async ()=>{ if (tab !== 1) { const ok = await checkHospitalMobile(); if (ok) setTab(1); } }}  className={tab===1?"nav-link active":"nav-link"} type="button" role="tab">{t('profile.adminInfo')}</span>
													</li>
						</ul>
						<div className="tab-content">
						{/*TAB-01*/}						
						{tab===0 && <div>
								<form autoComplete="off">
									<div className="row">
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.organisationName')} </label>
												<input onChange={handleChange} value={data.name?data.name:''} name="name" type="text" className="form-control" placeholder={t('profile.organisationName')} />
												{error && error.name && <span className="required">{error.name}</span>}
											</div>
											
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.organisationWebsite')}</label>
												<input onChange={handleChange} value={data.website?data.website:''} name="website" type="text" className="form-control" placeholder={t('profile.organisationWebsite')} />
												{error && error.website && <span className="required">{error.website}</span>}
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.phoneNumber')}</label>
												<PhoneInput
												  inputProps={{
                                                  name: 'mobileNumber',
												  style: { width: '100%'}}}
												  country={'us'}
												   value={data?.mobileNumberWithCode?data?.mobileNumberWithCode:''}
                                                   onChange={handlePhone}
												/>
												{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
												{!isValid && !error.mobileNumber && <span className="required">{t('error.validPhoneNumber')}</span>}
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.emailAddress')}</label>
												<input  onChange={handleChange} value={data.email?data.email:''} name="email" type="text" className="form-control" placeholder="youremail@mail.com" />
												{error && error.email && <span className="required">{error.email}</span>}
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.addressOne')}</label>
												<input onChange={handleChange} value={data.address_one?data.address_one:''} name="address_one" type="text" className="form-control"  placeholder={t('common.addressLine1')} />
												{error && error.address_one && <span className="required">{error.address_one}</span>}
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.addressTwo')}</label>
												<input onChange={handleChange} value={data.address_two?data.address_two:''} name="address_two" type="text" className="form-control"  placeholder={t('common.addressLine2')} />
												{error && error.address_two && <span className="required">{error.address_two}</span>}
											</div>
										</div>
										<div className="col-lg-4 col-md-6">
											<div className=" form-group">
												<label>{t('profile.city')} </label>
												<Autocomplete
											value={data?.city?data.city:''}
											className="form-control" 
											placeholder={t('common.city')} 
											onChange={changeCity}
											 onPlaceSelected={selectCity}
											types={['(cities)']}		
											/>
												{error && error.city && <span className="required">{error.city}</span>}
											</div>
										</div>
										<div className="col-lg-4 col-md-6">
											<div className=" form-group">
												<label>{t('profile.state')} </label>
												<input onChange={handleChange} readOnly value={data.state?data.state:''} name="state" type="text" className="form-control" placeholder={t('common.state')} />
												{error && error.state && !data.state && <span className="required">{error.state}</span>}
											</div>
										</div>
										<div className="col-lg-4 col-md-6">
											<div className=" form-group">
												<label>{t('profile.zipCode')} </label>
												<input onChange={handleChange} value={data.zipcode?data.zipcode:''} name="zipcode" type="text" className="form-control" placeholder={t('common.zipCode')} />
												{error && error.zipcode && <span className="required">{error.zipcode}</span>}
											</div>
										</div>
									</div>
									{/*Prev-Next Button Section*/}
									<div className="row mt-3">								
										<div className="col-lg-12 text-end">
										<button onClick={goNext(0)} type="button" className="btn btn-tmBlue btnNext"><i className="iconly-Light-ArrowRight align-middle"></i> {t('profile.next')}</button>
										</div>
									</div>
								</form>
							</div>}
								{/* End Form Section */}
								<div className="tab-content">
								{/*TAB-02*/}
							{tab===1 &&<div >
								<form>
									<div className="row">																						
										<div className="col-lg-12">
											<div className="form-group row">										
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
													<label>{t('profile.firstName')} </label>
														<input onChange={handleChange} value={data.admin_first_name?data.admin_first_name:''} name="admin_first_name" type="text" className="form-control" placeholder={t('profile.firstName')}/>
														{error && error.admin_first_name && <span className="required">{error.admin_first_name}</span>}
													</div>
												</div>									
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
													<label>{t('profile.lastName')} </label>
														<input onChange={handleChange} value={data.admin_last_name?data.admin_last_name:''} name="admin_last_name" type="text" className="form-control" placeholder={t('profile.lastName')}/>
														{error && error.admin_last_name && <span className="required">{error.admin_last_name}</span>}
													</div>
												</div>									
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
													<label>{t('profile.role')} </label>
														<input defaultValue="Admin" type="text" className="form-control" placeholder="Admin Role" disabled/>
													</div>
												</div>	
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
													<label>{t('profile.phoneNumber')}</label>
												<PhoneInput
												  inputProps={{
                                                  name: 'admin_mobileNumber',
												  style: { width: '100%'}}}
												  country={'us'}
												   value={data?.admin_mobileNumberWithCode?data?.admin_mobileNumberWithCode:''}
                                                   onChange={handlePhone}
												/>
{/* 												{error && error.admin_mobileNumber && <span className="required">{error.admin_mobileNumber}</span>} */}
												{!isValid && !error.admin_mobileNumber && <span className="required">{t('error.validPhoneNumber')}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
													<label>{t('profile.emailAddress')} </label>
														<input onChange={handleChange} value={data.admin_email?data.admin_email:''} name="admin_email" type="text" className="form-control" placeholder="youremail@mail.com"/>
														{error && error.admin_email && <span className="required">{error.admin_email}</span>}
													</div>
												</div>
												{/* <div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.gender}</label>
														<select name="admin_gender" value={data?.admin_gender?data.admin_gender:''} onChange={handleChange} className="form-select">
														<option value='' disabled>{t('profile.selectGender}</option>
														<option value="0" >{t('profile.male}</option>
														<option value="1" >{t('profile.female}</option>
														</select>
														{error && error.admin_gender && <span className="required">{error.admin_gender}</span>}
													</div>
												</div> */}
												<div className="col-lg-12">
													<div className=" form-group">
													<label>{t('profile.webURL')}</label>
														<input defaultValue={data?.website} type="text" className="form-control bg-light" disabled/>
													</div>
												</div>	
											</div>	
										</div>	
									</div>	
									{/*Prev-Next Button Section*/}
									<div className="row">								
										<div className="col-lg-12 text-end">
											<button onClick={()=>setTab(0)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
											<button onClick={handleSubmit} type="button" className="btn btn-tmBlue" ><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
										</div>
									</div>
								</form>
								</div>}	
							</div>
						</div>
					</div>								
				</div>
            </div>
        </div>
    </section>
	{/* End Page Content Section */}	
	</main>
  );	
	
};


export default AddHospital;